import Offcanvas from 'react-bootstrap/Offcanvas';
import { OffcanvasHeaderProps } from 'react-bootstrap/esm/OffcanvasHeader';
import { IDrawerStyles, useDrawerStyles } from "..";

export interface DrawerHeaderProps extends OffcanvasHeaderProps {
    controlStyles?: IDrawerStyles | undefined;
}

const ComponentProps = (props: DrawerHeaderProps): OffcanvasHeaderProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = (props) => {  
    const styles: IDrawerStyles = useDrawerStyles();
    const className: string = props.className ?? "border-bottom mx-2 pb-1 px-1 pt-4";

    return (
        <Offcanvas.Header {...ComponentProps(props)} className={className} style={{ ...styles.container, ...props.style }} />
    );
};